import React from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import { colors, typography } from '../theme';
import { ProviderIndicator, MessagingProvider } from './ProviderIndicator';
import { useThemedStyles } from '../hooks/useThemedStyles';

interface AvatarWithProviderBadgeProps {
  name: string;
  provider: MessagingProvider;
  imageUrl?: string;
  size?: number;
}

export const AvatarWithProviderBadge: React.FC<AvatarWithProviderBadgeProps> = ({
  name,
  provider,
  imageUrl,
  size = 50,
}) => {
  const styles = useThemedStyles(getStyles);
  const initials = name?.trim()?.charAt(0)?.toUpperCase() || 'N';
  const badgeSize = 20;
  const badgeOffset = Math.round(badgeSize * 0.35);

  return (
    <View style={[styles.container, { width: size, height: size }]}> 
      <View style={[styles.avatar, { width: size, height: size, borderRadius: size / 2 }]}> 
        {imageUrl ? (
          <Image source={{ uri: imageUrl }} style={[styles.avatarImage, { width: size, height: size, borderRadius: size / 2 }]} />
        ) : (
          <Text style={[styles.avatarText, { fontSize: Math.round(size * 0.36) }]}>{initials}</Text>
        )}
      </View>
      <View
        style={[
          styles.badge,
          {
            width: badgeSize,
            height: badgeSize,
            right: -badgeOffset,
            bottom: -badgeOffset,
          },
        ]}
      >
        <ProviderIndicator provider={provider} size="small" />
      </View>
    </View>
  );
};

const getStyles = () => StyleSheet.create({
  container: {
    position: 'relative',
  },
  avatar: {
    backgroundColor: colors.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarImage: {
    resizeMode: 'cover',
  },
  avatarText: {
    color: colors.white,
    fontFamily: typography.fontFamily.medium,
    fontWeight: '600',
  },
  badge: {
    position: 'absolute',
    backgroundColor: colors.background.surface,
    borderRadius: 999,
    padding: 0,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
    elevation: 3,
  },
});
